import {
  Button,
  Card,
  Col,
  Collapse,
  Layout,
  Modal,
  Row,
  Select,
  Skeleton,
  Space,
  Tag,
  theme,
  Typography,
} from "antd";
import React, { useEffect } from "react";
import {
  changePositionInterprete,
  changeStatusInterprete,
  getInterpretesSearch,
  initPrestationSlice,
  setPropertiesPrestation,
  setSelectedInterprete,
  updatePrestation,
} from "../Slices/Prestation.slice";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import CustomTable from "../../../shared/components/CustomTable";
import {
  formatCurrency,
  languagesList,
  renderUserGenderShort,
  renderUserName,
  statusOption,
  statusPrestationsValues,
} from "../../../utils/constants";
import routes from "../../../engine/routes";
import {
  expandedRowRenderDetailInterpretes,
  prestationInterpretesColumns,
} from "./Prestation.interpretes.table";
import { TbUserSearch } from "react-icons/tb";
import { RenderTitle } from "../../../engine/AuthRoute/navigationHelper";
import { PrestationHeader } from "../../../shared/components/PrestationHeader/PrestationHeader";

const { Content, Sider, Header, Footer } = Layout;

export function PrestationInterpretes({ unitId, expanded, onClose, route }) {
  const { id } = useParams();

  const navigate = useNavigate();

  const { prestation, loading, interpretesHasSearch } = useSelector(
    state => state.prestation,
  );

  const getInterpretesSearchs = () => {
    dispatch(getInterpretesSearch(id));
  };

  useEffect(() => {
    if (
      prestation.interpretesStatus.length === 0 &&
      interpretesHasSearch === false &&
      prestation._id !== undefined
    ) {
      getInterpretesSearchs();
    }
  }, []);


  const { init, clear } = initPrestationSlice({ id });

  const dispatch = useDispatch();

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const { name, archived } = prestation;

  const inputs = [
    {
      parentLabel: "",
      children: [
        {
          label: "N° de commande",
          name: "reference",
          required: true,
          disabled: true,
          capitalize: false,
          type: "input",
          value: prestation.reference,
          variant: "important",
          col: 12,
        },
      ],
    },
  ];

  const renderSearchChild = () => {
    return <div>Search</div>;
  };

  const saveInterpretesSearch = async () => {
    let data = {};
    data.steps ??= {};

    data.steps.complements = true;

    await dispatch(setPropertiesPrestation(data));
    await dispatch(updatePrestation());
    await navigate(routes.prestations(id).detailInformations.path);
  };

  const sortingInterpretes = (a, b) => {
    // Define the sorting order for statuses
    const statusOrder = {
      selected: 1,
      invited: 2,
      relance: 3,
      refused: 4,
      not_invited: 5,
      not_available: 5,
      // Add other statuses here with their respective sort order
      // For example:
      // 'accepted': 2,
    };

    // Default to a high sort order if status is not recognized
    const aStatusOrder = statusOrder[a.status] || 99;
    const bStatusOrder = statusOrder[b.status] || 99;

    // First sort by status
    if (aStatusOrder !== bStatusOrder) {
      return aStatusOrder - bStatusOrder;
    }

    // If statuses are the same, then sort by position
    return a.position - b.position;
  };

  // critere par qualifications et distance

  const renderResultsString = () => {
    return (
      <p>
        {!loading ? (
          <>
            {prestation.interpretesStatus.length > 0 && (
              <>
                <b>
                  {prestation.interpretesStatus.length} interprète
                  {prestation.interpretesStatus.length > 1 && "s"}
                </b>{" "}
                répondants à vos critères de recherches{" "}
                {prestation.interpretesStatus.length > 1 ? "sont" : "est"}{" "}
                disponibles
              </>
            )}

            {prestation.interpretesStatus.length === 0 &&
              "Aucun interprète correspond à vos critères de recherches"}
          </>
        ) : (
          <span className={"loadingdots"}>...</span>
        )}
      </p>
    );
  };

  const searchButton = () => (
    <Button
      disabled={prestation.status !== statusPrestationsValues.draft}
      type={"primary"}
      size={"large"}
      onClick={getInterpretesSearchs}
      loading={loading}
      icon={<TbUserSearch size={20} />}
    >
      Rechercher un interprète
    </Button>
  );

  return (
    <>
      <PrestationHeader
        title={routes.prestations(id).detailInterpretes.title}
      />

      {/*<Skeleton active title={"Hello"} paragraph={"hdhdhdhd"} />*/}

      <>
        <Space
          style={{
            marginTop: "10px",
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {renderResultsString()}
          {searchButton()}
        </Space>

        <CustomForm
          disabled={loading}
          initialValues={prestation}
          dataSource={inputs}
          labelCol={24}
          wrapperCol={24}
        />

        <CustomTable
          emptyText={
            <>
              <p>Cliquer ici pour rechercher les interprètes disponible</p>
              {searchButton()}
            </>
          }
          loading={loading}
          smTitle={item => {
            return (
              <div className={"alignHeaderPage"}>
                <h2 className={"noMargin"}>{item.user}</h2>
              </div>
            );
          }}
          scroll={{ y: 1000, x: 1000 }}
          rowKey={i => i.interprete._id}
          columns={prestationInterpretesColumns(prestation)}
          customRowClassName={record => {
            return record.status === "refused" ||
              record.status === "not_invited" ||
              record.status === "not_available"
              ? "rowOpacity"
              : "";
          }}
          dataSource={prestation.interpretesStatus
            .filter(e => e.hidden === false)
            .sort(sortingInterpretes)}
          expandable={{
            // expandRowByClick: true,
            expandedRowRender: expandedRowRenderDetailInterpretes,
            rowExpandable: record => record.name !== "Not Expandable",
          }}
        />
        <div style={{ textAlign: "right", paddingTop: 15 }}>
          <Button
            disabled={
              prestation.interpretesStatus.length === 0 ||
              (prestation.status !== statusPrestationsValues.draft &&
                prestation.status !== statusPrestationsValues.waiting)
            }
            onClick={saveInterpretesSearch}
            size={"middle"}
            type={"primary"}
          >
            Sauvegarder & suivant
          </Button>
        </div>
      </>
    </>
  );
}
